<template>
  <div class="c-conetntsSelect">
    <div class="c-conetntsSelect_input">
      <c-select
        :name="requestItem.name"
        v-model="selectedValue"
      >
        <option
          v-for="selectItem in requestItem.selectItemsList"
          :key="selectItem.id"
          :value="selectItem.value"
        >{{ selectItem.label }}</option>
      </c-select>
      <span>
        {{ requestItem.optionJson.unit }}
      </span>
    </div>
    <other-input
      :request-item="requestItem"
      :selected-value="selectedValue"
      @change="changeOther"
      @toggle="toggleOther"
    />
  </div>
</template>
<script>
import OtherInput from './OtherInput'

export default {
  name: 'ConetntsSelect',
  components: {
    OtherInput
  },
  props: {
    requestItem: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedValue: null
    }
  },
  watch: {
    selectedValue() {
      this.$emit('change', {
        name: this.requestItem.name,
        value: this.selectedValue,
        isValid: this.isValid
      })
    }
  },
  computed: {
    isValid() {
      if (this.requestItem.requiredFlag && this.selectedValue === null) {
        return false
      }

      return true
    }
  },
  methods: {
    changeOther(inputItem) {
      this.$emit('change-other', {
        name: inputItem.name,
        value: inputItem.value,
        isValid: inputItem.isValid
      })
    },
    toggleOther(toggleItem) {
      this.$emit('toggle-other', {
        name: toggleItem.name,
        isShow: toggleItem.isShow
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.c-conetntsSelect {
  &_input {
    display: flex;

    align-items: center;
  }
}

@media (max-width: breakpoint(Requests, M)) {
  .c-conetntsSelect {
    &_input {
      font-size: 14px;

      /deep/ .select {
        margin-right: 4px;
        min-width: 100px;
        height: 40px;

        select {
          padding-left: 12px;
          min-width: 100px;
          height: 40px;
          font-size: 14px;
        }
      }
    }
  }
}

@media (min-width: breakpoint(Requests, M) + 1) {
  .c-conetntsSelect {
    &_input {
      font-size: 16px;

      /deep/ .select {
        margin-right: 8px;
        min-width: 100px;
        height: 48px;

        select {
          padding-left: 12px;
          min-width: 100px;
          height: 48px;
          font-size: 16px;
        }
      }
    }
  }
}
</style>
